import useLocalStorage from './useLocalStorage';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useInput = (key: string, initValue: any) => {
  const [value, setValue] = useLocalStorage(key, initValue);

  const reset = () => setValue(initValue);

  const attributeObj = {
    value,
    onChange: (e: { target: { value: unknown } }) => setValue(e.target.value),
  };

  return [value, reset, attributeObj];
};

export default useInput;
